export enum AbWebview {
  ABWEBVIEW_GROWTHCSI_SUCESSO_CADASTRO_DE_CORRETORA = "abwebview_growthcsi_sucesso_cadastro_de_corretora"
}
